type Props = {
  bannerImage: string;
  brandLogo?: string;
  title: string;
  bannerBackground?: string;
}
export default function NavigatorHeader({
  bannerImage,
  brandLogo,
  bannerBackground = '#F5F6FA',
  title,
}: Props) {

  return (
    <div>
      <div className="navigator-header">
        <div
          className="navigator-header__cover"
          style={{
            background: `url(${bannerImage}), ${bannerBackground}`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        />
        <div className="navigator-header__titlebar">
          <div className="navigator-header__row navigator-header__inner">
            <div className="navigator-header__logo">
              <div className="navigator-header__logocontent">
                <div
                  className="navigator-header__logoimg"
                  style={{ backgroundImage: 'url("' + brandLogo + '")' }}
                />
              </div>
            </div>
            <div className="navigator-header__title">
              {title}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
